export const getFlyout = ({ colors, radii }) => ({
  bg: colors.white,
  radius: radii.small,
  triangle: {
    borderColor: colors.lightgray[700],
  },
})
